import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "../lib/auth";
import { BRAND_LOGO } from "../lib/brand";
import { toast } from "sonner";
import SelfieCapture from "../components/brand/SelfieCapture";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({
    full_name: "", nickname: "", email: "", password: "", phone: "", birthday: "", gender: "", city: "",
  });
  const [loading, setLoading] = useState(false);
  const [showSelfie, setShowSelfie] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register({ ...form, birthday: form.birthday || null });
      toast.success("Account created. Take your identity selfie to continue.");
      setShowSelfie(true);
    } catch (err) {
      toast.error(formatApiError(err));
      setLoading(false);
    }
  };

  const afterSelfie = () => {
    toast.success("Identity verified. Complete your membership payment to activate.");
    nav("/membership/payment");
  };

  if (showSelfie) {
    return (
      <SelfieCapture
        onCaptured={afterSelfie}
        subtitle="Welcome to The Social Circle. Take your identity verification selfie — this one-time photo confirms the privilege is truly yours."
      />
    );
  }

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-6">
      <div className="max-w-2xl w-full">
        <div className="text-center mb-10">
          <Link to="/" className="inline-flex flex-col items-center gap-2">
            <img src={BRAND_LOGO} alt="" className="h-16 w-16 rounded-full ring-1 ring-[#D4AF37]/40" />
            <p className="font-display text-2xl text-white tracking-wide">THE SOCIAL CIRCLE</p>
            <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37]">by Cornerstone</p>
          </Link>
        </div>

        <div className="tsc-card p-8" data-testid="register-card">
          <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37]">Members-only · Approval required</p>
          <h1 className="mt-2 font-display text-3xl text-white">Join the Circle</h1>
          <p className="text-white/55 text-sm mt-2">Fill out the form below. Next you&apos;ll take a quick identity selfie, then complete your GCash payment to activate.</p>

          <form onSubmit={submit} className="mt-7 grid sm:grid-cols-2 gap-4">
            <div className="sm:col-span-2">
              <label className="text-[10px] tracking-luxe uppercase text-white/60">Full name</label>
              <input required value={form.full_name} onChange={(e) => set("full_name", e.target.value)} className="tsc-input mt-1.5" data-testid="register-fullname" />
            </div>
            <div>
              <label className="text-[10px] tracking-luxe uppercase text-white/60">Nickname</label>
              <input value={form.nickname} onChange={(e) => set("nickname", e.target.value)} className="tsc-input mt-1.5" data-testid="register-nickname" />
            </div>
            <div>
              <label className="text-[10px] tracking-luxe uppercase text-white/60">Phone</label>
              <input required value={form.phone} onChange={(e) => set("phone", e.target.value)} className="tsc-input mt-1.5" data-testid="register-phone" />
            </div>
            <div>
              <label className="text-[10px] tracking-luxe uppercase text-white/60">Email</label>
              <input required type="email" value={form.email} onChange={(e) => set("email", e.target.value.toLowerCase())} className="tsc-input mt-1.5" data-testid="register-email" />
            </div>
            <div>
              <label className="text-[10px] tracking-luxe uppercase text-white/60">Password</label>
              <input required type="password" minLength={6} value={form.password} onChange={(e) => set("password", e.target.value)} className="tsc-input mt-1.5" data-testid="register-password" />
            </div>
            <div>
              <label className="text-[10px] tracking-luxe uppercase text-white/60">Birthday</label>
              <input type="date" value={form.birthday} onChange={(e) => set("birthday", e.target.value)} className="tsc-input mt-1.5" data-testid="register-birthday" />
            </div>
            <div>
              <label className="text-[10px] tracking-luxe uppercase text-white/60">City</label>
              <input value={form.city} onChange={(e) => set("city", e.target.value)} className="tsc-input mt-1.5" data-testid="register-city" />
            </div>
            <div className="sm:col-span-2 mt-2">
              <button type="submit" disabled={loading} className="tsc-btn-gold w-full" data-testid="register-submit">
                {loading ? "Activating…" : "Continue · Take selfie"}
              </button>
            </div>
          </form>
          <p className="text-white/55 text-xs mt-6 text-center">Already a member? <Link to="/login" className="text-[#D4AF37]">Sign in</Link></p>
        </div>
      </div>
    </div>
  );
}
